/**
 * rankColor — Stream H (R4)
 *
 * 1:1-Portierung von `transmit_color` aus dem v1-Monolithen
 * (app/helpers/application_helper.rb:245-265). Die Schwellwerte beziehen sich
 * auf das PERZENTIL des 7-Tage-Rangs (100 = bester Hotspot im Netz), nicht auf
 * die Rangzahl selbst.
 *
 * Bewusst Hex-Werte statt Design-Tokens: die sechs Stufen sind eine eigene,
 * in v1 etablierte Skala (Krone) und keine semantischen Status-Farben. Sie
 * haben in Light und Dark denselben Kontrastbedarf, weil sie immer auf einer
 * Icon-Flaeche und nie als Text-auf-Hintergrund verwendet werden.
 */

/** Farbe fuer "kein Rang vorhanden" (Cron noch nicht gelaufen / keine rewards_7d). */
export const RANK_COLOR_UNKNOWN = '#888888'

export type RankTier = 'top' | 'high' | 'good' | 'mid' | 'low' | 'bottom' | 'unknown'

/**
 * Perzentil -> Farbe (v1 transmit_color).
 * >90 violett, >75 gruen, >50 hellgruen, >25 gelb, >10 orange, sonst rot.
 * null/undefined/NaN -> grau.
 */
export function rankColor(percentile: number | null | undefined): string {
  if (percentile == null || Number.isNaN(percentile)) return RANK_COLOR_UNKNOWN
  if (percentile > 90) return '#7266BA'
  if (percentile > 75) return '#29D344'
  if (percentile > 50) return '#76F013'
  if (percentile > 25) return '#FEF734'
  if (percentile > 10) return '#F8BB32'
  return '#ED462F'
}

/** Stufenname zum Perzentil — fuer i18n-Tooltips und Tests. */
export function rankTier(percentile: number | null | undefined): RankTier {
  if (percentile == null || Number.isNaN(percentile)) return 'unknown'
  if (percentile > 90) return 'top'
  if (percentile > 75) return 'high'
  if (percentile > 50) return 'good'
  if (percentile > 25) return 'mid'
  if (percentile > 10) return 'low'
  return 'bottom'
}

/**
 * Issue #106: `percentile` ist BE-seitig so definiert, dass rank #1 (der
 * beste Hotspot) einen Wert nahe 100 bekommt (siehe Kopfkommentar oben,
 * `rank_percentile = ((total - rank + 1) / total) * 100`) -- 100 bedeutet
 * hier "Spitzenplatz". Der UI-Text "Top {{value}} %" folgt aber der
 * ueblichen Lesart "Top X %" = "unter den besten X % " (niedriger = besser,
 * z.B. "Top 1 %"), wofuer der Rohwert invertiert werden muss. Ohne diese
 * Umrechnung zeigte JEDER Spitzenreiter (Rang #1, #2, ...) faelschlich
 * "Top 100.0 %" statt "Top 0.0 %" -- rankColor/rankTier bleiben bewusst auf
 * dem Rohwert (100 = bester Tier-Score), nur die Anzeige wird gedreht.
 */
export function formatTopPercent(percentile: number | null | undefined): string | null {
  if (percentile == null || Number.isNaN(percentile)) return null
  return (100 - percentile).toFixed(1)
}
